import { render, staticRenderFns } from "./SkillAssign.vue?vue&type=template&id=0d5aae5b&scoped=true"
import script from "./SkillAssign.vue?vue&type=script&lang=js"
export * from "./SkillAssign.vue?vue&type=script&lang=js"
import style0 from "./SkillAssign.vue?vue&type=style&index=0&id=0d5aae5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5aae5b",
  null
  
)

export default component.exports